export const UD_COOKIES = {
  FIRST_VISIT_COOKIE_KEY: 'ud_firstvisit'
};
//# sourceMappingURL=constants.js.map